import { Modal, Text, Button } from "@simplybusiness/mobius";
import type { AmbiguousTradePair } from "./types";
import { AMBIGUOUS_TRADE_MODAL_TEST_IDS } from "./constants";
import "./AmbiguousTradeModal.css";

type AmbiguousTradeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  confirmTrade: (trade?: string) => void;
  tradePair?: AmbiguousTradePair;
};

export type { AmbiguousTradeModalProps };

export const AmbiguousTradeModal = ({
  isOpen,
  onClose,
  confirmTrade,
  tradePair,
}: AmbiguousTradeModalProps) => {
  if (!tradePair) return null;

  const {
    selectedTrade,
    selectedTradeDefinition,
    alternativeTrade,
    alternativeTradeHint,
  } = tradePair;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="mobius-ambiguous-trade-modal"
      data-testid={AMBIGUOUS_TRADE_MODAL_TEST_IDS.MODAL}
    >
      <Modal.Content>
        <div className="mobius-ambiguous-trade-modal__content-section">
          <Text className="mobius-ambiguous-trade-modal__text mobius-ambiguous-trade-modal__heading">
            We want to make sure you selected the right trade
          </Text>
          <Text className="mobius-ambiguous-trade-modal__text">
            We define{" "}
            <em className="mobius-ambiguous-trade-modal__emphasized-text">
              {selectedTrade}
            </em>{" "}
            as {selectedTradeDefinition}
          </Text>
          <Text className="mobius-ambiguous-trade-modal__text">
            {alternativeTradeHint}, you should select the trade{" "}
            <em className="mobius-ambiguous-trade-modal__emphasized-text">
              {alternativeTrade}
            </em>
            .
          </Text>
        </div>
        <div className="mobius-ambiguous-trade-modal__content-section">
          <Text className="mobius-ambiguous-trade-modal__text mobius-ambiguous-trade-modal__heading">
            Select an option based on the description above
          </Text>
          <Button
            variant="secondary"
            onClick={() => confirmTrade(selectedTrade)}
            data-testid={AMBIGUOUS_TRADE_MODAL_TEST_IDS.CONFIRM_SELECTED}
          >
            I am a {selectedTrade}
          </Button>
          <Button
            variant="secondary"
            onClick={() => confirmTrade(alternativeTrade)}
            data-testid={AMBIGUOUS_TRADE_MODAL_TEST_IDS.CONFIRM_ALTERNATIVE}
          >
            I am a {alternativeTrade}
          </Button>
          <div>
            <Text className="mobius-ambiguous-trade-modal__text">Or </Text>
            <Button
              variant="link"
              size="sm"
              onClick={() => confirmTrade()}
              data-testid={AMBIGUOUS_TRADE_MODAL_TEST_IDS.SELECT_ANOTHER}
            >
              select another trade
            </Button>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};
